<div class="flex flex-col h-full max-h-[80vh]">
    <!-- Search input -->
    <div class="flex items-center gap-4 px-6 py-6">
        <div class="flex-1 relative">
            <img
                src="/assets/images/shared/search-icon.svg"
                alt="Search"
                class="absolute left-4 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
            <input
                id="searchInput"
                type="text"
                class="w-full pl-12 pr-4 py-3 rounded-xl border border-[#E7EAF0] outline-none"
                placeholder="Search for people, groups, posts, or hashtags..."
                [value]="searchValue()"
                (input)="onSearchInput($event.target.value)" />
        </div>
        <img
            src="/assets/images/shared/cross-black-icon.svg"
            alt="Close"
            class="h-6 w-6 cursor-pointer"
            (click)="onCancel()" />
    </div>

    @if (showFilterActions()) {
        <!-- Filter tabs -->
        <div class="px-6">
            <div class="flex gap-2 overflow-x-auto pb-2">
                <button
                    type="button"
                    class="flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium whitespace-nowrap flex-shrink-0"
                    [ngClass]="
                        selectedTab === SearchTypeEnum.All ? 'bg-[#4F66FF] text-white' : 'bg-[#F3F4F6] text-[##364153]'
                    "
                    [disabled]="selectedTab === SearchTypeEnum.All"
                    (click)="selectTab(SearchTypeEnum.All)">
                    <img
                        alt="All"
                        class="h-4 w-4"
                        [src]="
                            selectedTab === SearchTypeEnum.All
                                ? '/assets/images/shared/star-white-icon.svg'
                                : '/assets/images/shared/star-black-icon.svg'
                        " />
                    {{ getSearchTypeLabel(SearchTypeEnum.All) }}
                </button>

                <button
                    type="button"
                    class="flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium whitespace-nowrap flex-shrink-0"
                    [ngClass]="
                        selectedTab === SearchTypeEnum.Tag ? 'bg-[#4F66FF] text-white' : 'bg-[#F3F4F6] text-[##364153]'
                    "
                    [disabled]="selectedTab === SearchTypeEnum.Tag"
                    (click)="selectTab(SearchTypeEnum.Tag)">
                    <img
                        alt="Posts"
                        class="h-4 w-4"
                        [src]="
                            selectedTab === SearchTypeEnum.Tag
                                ? '/assets/images/shared/hashtag-white-icon.svg'
                                : '/assets/images/shared/hashtag-black-icon.svg'
                        " />
                    {{ getSearchTypeLabel(SearchTypeEnum.Tag) }}
                </button>

                <button
                    type="button"
                    class="flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium whitespace-nowrap flex-shrink-0"
                    [ngClass]="
                        selectedTab === SearchTypeEnum.Group
                            ? 'bg-[#4F66FF] text-white'
                            : 'bg-[#F3F4F6] text-[##364153]'
                    "
                    [disabled]="selectedTab === SearchTypeEnum.Group"
                    (click)="selectTab(SearchTypeEnum.Group)">
                    <img
                        alt="Groups"
                        class="h-4 w-4"
                        [src]="
                            selectedTab === SearchTypeEnum.Group
                                ? '/assets/images/shared/group-white-icon.svg'
                                : '/assets/images/shared/group-icon.svg'
                        " />
                    {{ getSearchTypeLabel(SearchTypeEnum.Group) }}
                </button>

                <button
                    type="button"
                    class="flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium whitespace-nowrap flex-shrink-0"
                    [ngClass]="
                        selectedTab === SearchTypeEnum.User ? 'bg-[#4F66FF] text-white' : 'bg-[#F3F4F6] text-[##364153]'
                    "
                    [disabled]="selectedTab === SearchTypeEnum.User"
                    (click)="selectTab(SearchTypeEnum.User)">
                    <img
                        alt="People"
                        class="h-4 w-4"
                        [src]="
                            selectedTab === SearchTypeEnum.User
                                ? '/assets/images/shared/people-white-icon.svg'
                                : '/assets/images/shared/people-icon.svg'
                        " />
                    {{ getSearchTypeLabel(SearchTypeEnum.User) }}
                </button>
            </div>
        </div>
    }

    <!-- Results section -->
    <div
        class="flex-1 overflow-y-auto px-6 min-h-[300px] popup-scrollable-main"
        [ngClass]="showFilterActions() ? 'py-6' : ''">
        @if (!searchValue() || searchValue().trim() === '') {
            @if (recentSearches().length > 0) {
                <div class="mb-6">
                    <p class="text-[#0A0A0A] font-medium mb-3">Recent Searches</p>
                    @for (item of recentSearches(); track item.name) {
                        <div class="flex items-center gap-3 mb-3 rounded p-2">
                            <div
                                class="flex items-center gap-3 flex-1 cursor-pointer"
                                (click)="onSummaryItemClick(item)">
                                <img
                                    src="/assets/images/shared/search-icon.svg"
                                    alt="Search"
                                    class="h-5 w-5 text-gray-400" />
                                <p>{{ item.name }}</p>
                            </div>

                            <img
                                src="/assets/images/shared/cross-black-icon.svg"
                                alt="Remove"
                                class="h-4 w-4 cursor-pointer"
                                (click)="removeRecentSearch(item)" />
                        </div>
                    }
                </div>
            }

            @if (recentlyAccessed().length > 0) {
                <div class="mb-6">
                    <p class="text-[#0A0A0A] font-medium mb-3">Recently Accessed</p>
                    @for (item of recentlyAccessed(); track item) {
                        <div class="flex items-center gap-3 rounded p-2">
                            <div class="flex-1 cursor-pointer" (click)="addToRecentlyAccessed(item.data, item.type)">
                                @switch (item.type) {
                                    @case (SearchTypeEnum.Tag) {
                                        <app-post [post]="asPost(item)" [isShowActions]="false"></app-post>
                                    }
                                    @case (SearchTypeEnum.Group) {
                                        <app-group [group]="asGroup(item)"></app-group>
                                    }
                                    @case (SearchTypeEnum.User) {
                                        <app-people [people]="asUser(item)"></app-people>
                                    }
                                }
                            </div>

                            <img
                                src="/assets/images/shared/cross-black-icon.svg"
                                alt="Remove"
                                class="h-4 w-4 mb-2 cursor-pointer"
                                (click)="removeRecentlyAccessed(item)" />
                        </div>
                    }
                </div>
            }

            @if (recentSearches().length === 0 && recentlyAccessed().length === 0) {
                <div class="flex flex-col items-center justify-center p-6 h-[255px]">
                    <div class="flex flex-col items-center justify-center gap-3">
                        <img alt="People" class="h-12 w-auto" src="/assets/images/shared/search-blue-icon.svg" />
                        <p class="text-[#0A0A0A] font-medium">No recent search</p>
                    </div>
                </div>
            }
        } @else if (isSearchSummaryLoading()) {
            <!-- Show search summary skeleton when loading summary -->
            <ng-container *ngTemplateOutlet="summarySkeleton"></ng-container>
            <ng-container *ngTemplateOutlet="summarySkeleton"></ng-container>
            <ng-container *ngTemplateOutlet="summarySkeleton"></ng-container>
        } @else if (isSearchLoading()) {
            <!-- Show skeletons based on selected tab when loading detailed results -->
            @switch (selectedTab) {
                @case (SearchTypeEnum.All) {
                    <ng-container *ngTemplateOutlet="allSkeleton"></ng-container>
                }
                @case (SearchTypeEnum.Tag) {
                    <ng-container *ngTemplateOutlet="tagSkeleton"></ng-container>
                }
                @case (SearchTypeEnum.Group) {
                    <ng-container *ngTemplateOutlet="groupSkeleton"></ng-container>
                }
                @case (SearchTypeEnum.User) {
                    <ng-container *ngTemplateOutlet="userSkeleton"></ng-container>
                }
            }
        } @else if (showSearchSummary() && showSearchSummary().length > 0) {
            <div class="mb-3">
                @for (item of showSearchSummary(); track item) {
                    <div class="flex items-center gap-3 py-3 px-4 cursor-pointer" (click)="onSummaryItemClick(item)">
                        <img src="/assets/images/shared/search-icon.svg" alt="Search" class="h-5 w-5 text-gray-400" />
                        <p>{{ item.name }}</p>
                    </div>
                }
            </div>
        } @else if (noResultsFound()) {
            <div class="flex flex-col justify-between p-6 h-full">
                <div class="flex flex-col items-center justify-center gap-3">
                    <img alt="People" class="h-12 w-auto" src="/assets/images/shared/search-blue-icon.svg" />
                    <p class="text-[#0A0A0A] font-medium">No results found for "{{ searchValue() }}"</p>
                    <p class="text-[0.875rem] text-[#6B7280] text-center">
                        Try different keywords, check your spelling,<br />
                        or browse our trending searches below.
                    </p>
                </div>

                <div class="mt-6 flex flex-col gap-2">
                    <p class="text-[#0A0A0A] font-medium">Suggestions:</p>
                    <p class="text-[0.875rem] text-[#6B7280]">• Try broader search terms</p>
                    <p class="text-[0.875rem] text-[#6B7280]">• Use more specific keywords</p>
                    <p class="text-[0.875rem] text-[#6B7280]">• Use hashtags like #prayer or #testimony</p>
                    <p class="text-[0.875rem] text-[#6B7280]">• Search for people by name or title</p>
                </div>
            </div>
        } @else {
            @switch (selectedTab) {
                @case (SearchTypeEnum.All) {
                    <ng-container *ngTemplateOutlet="allResults"></ng-container>
                }
                @case (SearchTypeEnum.Tag) {
                    <ng-container *ngTemplateOutlet="tagResults"></ng-container>
                }
                @case (SearchTypeEnum.Group) {
                    <ng-container *ngTemplateOutlet="groupResults"></ng-container>
                }
                @case (SearchTypeEnum.User) {
                    <ng-container *ngTemplateOutlet="userResults"></ng-container>
                }
            }
        }
    </div>
</div>

<ng-template #summarySkeleton>
    <div class="flex items-center gap-3 mb-3">
        <ngx-skeleton-loader class="w-5 h-5 rounded"></ngx-skeleton-loader>
        <ngx-skeleton-loader class="w-48 h-4 rounded"></ngx-skeleton-loader>
    </div>
</ng-template>

<ng-template #allSkeleton>
    <app-post-skeleton></app-post-skeleton>
    <app-group-skeleton></app-group-skeleton>
    <app-people-skeleton></app-people-skeleton>
</ng-template>
<ng-template #tagSkeleton>
    <app-post-skeleton></app-post-skeleton>
    <app-post-skeleton></app-post-skeleton>
    <app-post-skeleton></app-post-skeleton>
</ng-template>
<ng-template #groupSkeleton>
    <app-group-skeleton></app-group-skeleton>
    <app-group-skeleton></app-group-skeleton>
    <app-group-skeleton></app-group-skeleton>
</ng-template>
<ng-template #userSkeleton>
    <app-people-skeleton></app-people-skeleton>
    <app-people-skeleton></app-people-skeleton>
    <app-people-skeleton></app-people-skeleton>
</ng-template>

<ng-template #allResults>
    <div
        infiniteScroll
        [infiniteScrollContainer]="'.popup-scrollable-main'"
        [fromRoot]="true"
        [infiniteScrollDistance]="1"
        (scrolled)="loadMoreSearchResults()">
        @for (item of showPostSearchResult().post; track item) {
            <div (click)="addToRecentlyAccessed(item, SearchTypeEnum.Tag)">
                <app-post [post]="item" [isShowActions]="false"></app-post>
            </div>
        }
        @for (item of showGroupSearchResult().group; track item) {
            <div class="flex flex-col mb-4" (click)="addToRecentlyAccessed(item, SearchTypeEnum.Group)">
                <app-group [group]="item"></app-group>
            </div>
        }
        @for (item of showUserSearchResult().user; track item) {
            <div class="flex flex-col mb-4" (click)="addToRecentlyAccessed(item, SearchTypeEnum.User)">
                <app-people [people]="item"></app-people>
            </div>
        }
    </div>
</ng-template>
<ng-template #tagResults>
    <div
        infiniteScroll
        [infiniteScrollContainer]="'.popup-scrollable-main'"
        [fromRoot]="true"
        [infiniteScrollDistance]="1"
        (scrolled)="loadMoreSearchResults()">
        @for (item of showPostSearchResult().post; track item) {
            <div (click)="addToRecentlyAccessed(item, SearchTypeEnum.Tag)">
                <app-post class="mb-0" [post]="item" [isShowActions]="false"></app-post>
            </div>
        }
    </div>
</ng-template>
<ng-template #groupResults>
    <div
        infiniteScroll
        [infiniteScrollContainer]="'.popup-scrollable-main'"
        [fromRoot]="true"
        [infiniteScrollDistance]="1"
        (scrolled)="loadMoreSearchResults()">
        @for (item of showGroupSearchResult().group; track item) {
            <div class="flex flex-col mb-4" (click)="addToRecentlyAccessed(item, SearchTypeEnum.Group)">
                <app-group [group]="item"></app-group>
            </div>
        }
    </div>
</ng-template>
<ng-template #userResults>
    <div
        infiniteScroll
        [infiniteScrollContainer]="'.popup-scrollable-main'"
        [fromRoot]="true"
        [infiniteScrollDistance]="1"
        (scrolled)="loadMoreSearchResults()">
        @for (item of showUserSearchResult().user; track item) {
            <div class="flex flex-col mb-4" (click)="addToRecentlyAccessed(item, SearchTypeEnum.User)">
                <app-people [people]="item"></app-people>
            </div>
        }
    </div>
</ng-template>
